<mat-radio-group class="flex flex-row lg:justify-end justify-between w-full"
  (ngModelChange)="onChange($event)"
  [(ngModel)]="keySelected">
  <mat-radio-button class="px-2" *ngFor="let key of filters; let i = index" [value]="key" [ngStyle]="radioStyles[i]">
    {{this.utils.traslatei18n(key)}}
  </mat-radio-button>
</mat-radio-group>
